import { NODE_DOMAIN } from "../../../URLCollection/Domain";

export const HealthURLs = {
  ADD_HEALTH_FORM: `${NODE_DOMAIN}/api/v1/health/add-form`,
};
